import IndexPage from 'flarum/components/IndexPage';

export default function() {
    IndexPage.prototype.getCurrentTag = function() {
        const slug = m.route.param('tags');
        let tag = null;
        if(slug) {
            tag = app.store.getBy('tags', 'slug', slug);
        }
        return tag;
    }
}
